import "./not-playing-background.less"
import LessonBackground from "./lesson-background"
import { usePlayState } from "play/hooks/use-play-state"

export default function NotPlayingBackground() {
  const { isBusinessVersion, theme } = usePlayState()
  return (
    <div className="not-playing-background">
      <LessonBackground
        isBusinessVersion={isBusinessVersion}
        theme={theme}
        foreground={
          <>
            <div className="boy" />
            <div className="girl" />
          </>
        }
        background={<div className="letter" />}
      />
    </div>
  )
}
